import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { PersonFill, BriefcaseFill } from "react-bootstrap-icons";
import axios from "axios";
import API_BASE_URL from "../config";

export default function RoleSelectPage() {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch companies for navigation logic
  useEffect(() => {
    async function fetchCompanies() {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }
        const res = await axios.get(`${API_BASE_URL}/companies`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCompanies(res.data || []);
      } catch (err) {
        console.error("fetchCompanies", err);
        setCompanies([]);
      }
    }
    fetchCompanies();
  }, [navigate]);

  const handleSelect = async (role) => {
    localStorage.setItem("activeRole", role);
    if (role === "customer") {
      navigate("/manage-bookings");
    } else {
      // Handle "user" role navigation
      try {
        setIsLoading(true);
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        // Check companies
        if (companies.length > 1) {
          navigate("/select-company");
        } else if (companies.length === 1) {
          // Fetch branches for the single company
          const company = companies[0];
          const res = await axios.get(`${API_BASE_URL}/companies/${company.id}/branches`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const branches = res.data || [];

          // Store selected company in localStorage for Sidebar.js
          localStorage.setItem("selectedCompany", JSON.stringify(company));

          if (branches.length > 1) {
            navigate("/select-branch");
          } else {
            navigate("/manage-company-bookings");
          }
        } else {
          // No companies, navigate to a fallback route (e.g., create company)
          navigate("/companies");
        }
      } catch (err) {
        console.error("handleSelect", err);
        navigate("/companies");
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <Container className="py-5 text-center">
      <h2 className="mb-4 fw-bold">Continue as</h2>
      <Row className="justify-content-center g-4">
        <Col xs={12} md={5}>
          <Card
            className="shadow-sm hover-shadow border-0"
            onClick={() => handleSelect("customer")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body>
              <PersonFill size={48} className="text-primary mb-3" />
              <Card.Title>Customer</Card.Title>
              <Card.Text>Book and manage your appointments easily.</Card.Text>
              <Button variant="primary" disabled={isLoading}>
                Continue as Customer
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={5}>
          <Card
            className="shadow-sm hover-shadow border-0"
            onClick={() => handleSelect("user")}
            style={{ cursor: "pointer" }}
          >
            <Card.Body>
              <BriefcaseFill size={48} className="text-success mb-3" />
              <Card.Title>Business Owner</Card.Title>
              <Card.Text>Manage your services, staff, and customers.</Card.Text>
              <Button variant="success" disabled={isLoading}>
                Continue as Business Owner
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}